module.exports = __webpack_public_path__ + "static/media/400116_02.5ffb9443.png";